import { xySortX } from 'ml-spectra-processing';
/**
 * Gets the Subfile flags.
 * @param flag - First byte of the subheader.
 * @returns The parameters.
 */
export function parseSubFlagParameters(flag) {
    return {
        changed: (flag & 1) !== 0,
        noPeakTable: (flag & 8) !== 0,
        modifiedArithmetic: (flag & 128) !== 0,
    };
}
/**
 * Parses the subheader (header of the subfile).
 * @param buffer - SPC buffer.
 * @returns subheader object.
 */
export function parseSubHeader(buffer) {
    return {
        parameters: parseSubFlagParameters(buffer.readUint8()),
        exponentY: buffer.readInt8(),
        indexNumber: buffer.readUint16(),
        startingZ: buffer.readFloat32(),
        endingZ: buffer.readFloat32(),
        noiseValue: buffer.readFloat32(),
        numberPoints: buffer.readUint32(),
        numberCoAddedScans: buffer.readUint32(),
        wAxisValue: buffer.readFloat32(),
        reserved: buffer.readChars(4).replaceAll('\u0000', '').trim(),
    };
}
/**
 * Set the X and Y axis (object with labels, values etc.)
 * @param x - X values array.
 * @param y - Y values array.
 * @param fileHeader - main file header.
 * @returns object with x and y as axis.
 */
export function setXYAxis(x, y, fileHeader) {
    const xAxis = /(?<label>.*?) ?[([](?<units>.*)[)\]]/.exec(fileHeader.xUnitsType);
    const yAxis = /(?<label>.*?) ?[([](?<units>.*)[)\]]/.exec(fileHeader.yUnitsType);
    const { x: oX, y: oY } = xySortX({ x, y });
    const variables = {
        x: {
            symbol: 'x',
            label: xAxis?.groups?.label || fileHeader.xUnitsType,
            units: xAxis?.groups?.units || '',
            data: oX,
            isDependent: false,
        },
        y: {
            symbol: 'y',
            label: yAxis?.groups?.label || fileHeader.yUnitsType,
            units: yAxis?.groups?.units || '',
            data: oY,
            isDependent: true,
        },
    };
    return variables;
}
//# sourceMappingURL=shared.js.map